module.exports = __webpack_public_path__ + "static/2nd-tpm-4-4b77ede2e076af5915d0965eb72a0100.jpg";